<div *ngIf="!isVertical" class="k-divider"></div>
<div *ngIf="isVertical" class="k-divider-vertical"></div>